var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3C5.92157 3 5.25 3.67157 5.25 4.5V19.5C5.25 20.3284 5.92157 21 6.75 21H17.25C18.0784 21 18.75 20.3284 18.75 19.5V8.25L13.5 3H6.75Z",
    fill: "#00AEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7292_34979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.25V3L18.75 8.25H13.5Z",
    fill: "#008DCF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92778 17.7852C8.73882 17.7852 8.58501 17.6313 8.58501 17.4424C8.58501 17.2578 8.73882 17.104 8.92778 17.104C9.10796 17.104 9.26616 17.2578 9.26616 17.4424C9.26616 17.6313 9.10796 17.7852 8.92778 17.7852ZM9.69419 15.3638H10.2567V17.8862C10.2567 18.4004 9.95347 18.6465 9.42612 18.6465C9.39097 18.6465 9.35581 18.6465 9.31187 18.6421V18.1851C9.34263 18.1895 9.36899 18.1895 9.39536 18.1895C9.61069 18.1895 9.69419 18.0796 9.69419 17.8818V15.3638ZM9.97544 15.0254C9.79966 15.0254 9.65024 14.8892 9.65024 14.7178C9.65024 14.5508 9.79966 14.4146 9.97544 14.4146C10.1556 14.4146 10.3006 14.5508 10.3006 14.7178C10.3006 14.8892 10.1556 15.0254 9.97544 15.0254ZM10.6803 18.6465V15.3638H11.2296V15.7549H11.2648C11.3527 15.5835 11.5285 15.333 11.9503 15.333C12.4997 15.333 12.9347 15.7637 12.9347 16.5591C12.9347 17.3457 12.5128 17.7939 11.9503 17.7939C11.5373 17.7939 11.3527 17.5479 11.2648 17.3721H11.2428V18.6465H10.6803ZM11.2296 16.5547C11.2296 17.0205 11.4318 17.3325 11.7965 17.3325C12.1657 17.3325 12.3634 17.0073 12.3634 16.5547C12.3634 16.1108 12.1701 15.79 11.7965 15.79C11.4318 15.79 11.2296 16.0933 11.2296 16.5547ZM14.3032 18.6948C13.6704 18.6948 13.2705 18.4136 13.2309 17.9653H13.789C13.8286 18.1719 14.0263 18.2729 14.312 18.2729C14.6459 18.2729 14.8657 18.1279 14.8657 17.7764V17.3193H14.8393C14.7514 17.4951 14.5625 17.7148 14.1494 17.7148C13.6 17.7148 13.165 17.3149 13.165 16.5371C13.165 15.7505 13.6 15.333 14.1538 15.333C14.5756 15.333 14.7514 15.5835 14.8393 15.7549H14.8657V15.3638H15.4194V17.7896C15.4194 18.4004 14.9492 18.6948 14.3032 18.6948ZM14.3032 17.2754C14.6635 17.2754 14.8701 17.0029 14.8701 16.5459C14.8701 16.0933 14.6679 15.79 14.3032 15.79C13.9296 15.79 13.7363 16.1108 13.7363 16.5459C13.7363 16.9854 13.934 17.2754 14.3032 17.2754Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7292_34979",
    x: 10.5,
    y: 1.5,
    width: 11.25,
    height: 11.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.20694 0 0 0 0 0.51735 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7292_34979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7292_34979",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileJpg);
export default __webpack_public_path__ + "static/media/file-jpg.adc599145f6d3f7806cd6ce472077aea.svg";
export { ForwardRef as ReactComponent };